  import React, { useEffect, useState } from 'react';

  import ComboBox from '../../../../../components/ComboBox';
  import CollapsableSection from '../../../../../components/CollapsibleSection';
  import ButtonForm from '../../../../../components/ButtonForm';
  import InputForm from '../../../../../components/InputForm';
  import SelectableList from '../../../../../components/SelectableList';
  import SelectionForm from '../../../../../components/SelectionForm';

  import CheckIco from '../../../../../components/icons/CheckIco';
  import TrashIco from '../../../../../components/icons/TrashIco';
  import AddIco from '../../../../../components/icons/AddIco';

  import Spinner from '../../../../../components/Spinner';
  import { useAuth } from '../../../../../providers/AuthContext';
  import { useNavigate } from 'react-router-dom';
  import { getAllParameters } from '../../../../../services/apiProcessParameteres';
  import { useAppContext } from '../../../../../providers/AppContext';
  import { useProcesses } from '../../../../../providers/ProcessesContext';
  import { translateDatePicker } from '../../../../utils';
  import { useDashboards } from '../../../../../providers/DashboardContext';
  import { useWidgets } from '../../../../../providers/WidgetContext';
  import { createWidget, getWidgetById, updateWidget } from '../../../../../services/apiWidgests';
  import { type } from '@testing-library/user-event/dist/type';
import DropdownSelectableList from '../../../../../components/icons/DropdownSelectableList';


  const ColumnField = ({ header , onDelete=() =>{}}) => {
    return (
      <div className='flex justify-between items-center w-full mr-3'>
        <div className='flex basis-1/3 items-center gap-1'>
          <span>{header.alias}</span>
        </div>
        <span className='basis-1/3 text-gray-400'>{header.key}</span>
        <button className="" onClick={() => onDelete(header)}>
          <TrashIco fill='red' />
        </button>
      </div>
    );
  };

  function StatusRegisterForm({onSubmit = () => {}, id}) {
    const {auth} = useAuth();
    const {addToast} = useAppContext();
    const navigate = useNavigate();

    const { addCard, assignSpace } = useWidgets();
    const { dashboard } = useDashboards();

    const [processList, setProcessList] = useState([]);
    const [selectedProcess, setSelectedProcess] = useState();
    const [parameters, setParameters] = useState();
    const [conf, setConf] = useState();
    const {menuItems} = useProcesses();
    const [statusField, setStatusField] = useState();
    const [detailField, setDetailField] = useState();
    const [dataRange, setDataRange] = useState('Asignar por dashboard');
    const [timeVariable, setTimeVariable] = useState("createdAt");
    const [title, setTitle] = useState('');
    const [validate, setValidate] = useState(false);
    const [stage,setStage] = useState("form");
    const [newRule, setNewRule] = useState({});

    const [variableTimeOptions, setVariableTimeOptions] = useState(
      {"createdAt": "Fecha de creación"}
    )

    //colores
    const colorOptions = {
      "pastel": "Paleta pastel",
      "blue": "Paleta azul",
      "red": "Paleta roja",
      "fixed": "Color fijo"
    }
              
    //backend flags
    const [loading, setLoading] = useState(true);
    const [fetchingParameters, setFetchingParameters] = useState(true);
    const [creatingWidget, setCreatingWidget] = useState(false);
    const [fetchingWidgetInfo, setFetchingWidgetInfo] = useState(true);

    //obtener info existente del widget
    const refreshWidgetInfo = () => {
      async function fetchWigdet(){
        const widget = await getWidgetById(id, auth?.token);
        return widget; 
      }
      try {
        setFetchingWidgetInfo(true);
        fetchWigdet().then(response => {
          console.log(response.configuration)
          setConf(response.configuration)
          setSelectedProcess(response.configuration.process.id)
          setDetailField(response.configuration.detailField)
          setStatusField(response.configuration.statusField)
          setTimeVariable(response.configuration.timeVariable)
          //setDataRange(response.configuration.dateRange.selectedRange === "byDashboard" ? "Asignar por dashboard": response.configuration.dateRange.selectedRange)
          setFetchingWidgetInfo(false);
          setTitle(response.title)
        }).catch(error => {
          if (error.response.status === 404){
            console.log("Widget no encontrado")
          }
          else if (error.response.status === 500){
            console.log("Error en el servidor, intente nuevamente")
          }
          else{
            navigate('/logout')
          }
        })
      } catch (error) {
        console.log(error,typeof(error));
        setFetchingWidgetInfo(false);
      }
    }

    const refreshParameters = () => {
      async function fetchParameters(){
        const parameters = await getAllParameters(selectedProcess, auth?.token);
        return parameters;
      }
      try {
        setFetchingParameters(true);
        fetchParameters().then(response => {
          console.log(console.log(response))
          let timeVars = {}
          setParameters(response.map(parameter => {
            //añadir variables de tiempo a la lista
            if (parameter.datatype === "date"){
              timeVars[parameter.key] = parameter.alias || parameter.key
            }
            return {
              key: parameter.key,
              alias: parameter.alias,
              type: parameter.datatype
            }
          }));
          //actualizar variables de tiempo
          setVariableTimeOptions({
            "createdAt": "Fecha de creación",
            ...timeVars
          })
          setFetchingParameters(false);
        }).catch(error => {
          if (error.response.status === 404){
            addToast("Proceso no encontrado",3)
          }
          else if (error.response.status === 500){
            addToast("Error en el servidor, intente nuevamente",2)
          }
          else if (error.response.status === 419){
            addToast("Sesión expirada",1)
            navigate('/logout')
          }
          else{
            navigate('/logout')
          }
        })
      } catch (error) {
        console.log(error, "a", typeof(error));
        setFetchingParameters(false);
      }
    }

    const createWidgetDB = () => {
      async function fetchWidget(){
        const position= assignSpace();
        const widget = await createWidget({
          type: "processStatusRegister",
          title: title,
          description: "",
          configuration: conf,
          dashboardId: dashboard._id,
          x: position.x,
          y: position.y,
          width: 200,
          height: 200,
        }, auth?.token);
        
        return widget;
      }
      try {
        setCreatingWidget(true);
        fetchWidget().then(response => {
          console.log(console.log(response));
          addCard (
            response._id,
            response.title,
            response.type,
            response.dashboardId,
            
          )
          onSubmit();
          setCreatingWidget(false);
          addToast("Widget "+ title + " creado exitosamente.",1)
        }).catch(error => {
          console.log(error)
          if (error.response.status === 404){
            addToast("Proceso no encontrado",3)
          }
          else if (error.response.status === 500){
            addToast("Error en el servidor, intente nuevamente",2)
          }
          else if (error.response.status === 419){
            addToast("Sesión expirada",1)
            navigate('/logout')
          }
          else{
            navigate('/logout')
          }
        })
      } catch (error) {
        console.log(error, "a", typeof(error));
        setCreatingWidget(false);
      }
    }

    const editWidgetDB = () => {
      async function saveWidget(){

        const widget = await updateWidget(id,{
          type: "processStatusRegister",
          title: title,
          description: "",
          configuration: conf,
          /* dashboardId: dashboard._id,
          x: position.x,
          y: position.y,
          width: 200,
          height: 200, */
        }, auth?.token);
        
        return widget;
      }
      try {
        setCreatingWidget(true);
        saveWidget().then(response => {
          console.log(console.log(response));
          
          onSubmit();
          setCreatingWidget(false);
          addToast("Widget "+ title + " editado exitosamente.",1);
        }).catch(error => {
          console.log(error)
          if (error.response.status === 404){
            addToast("Proceso no encontrado",3)
          }
          else if (error.response.status === 500){
            addToast("Error en el servidor, intente nuevamente",2)
          }
          else if (error.response.status === 419){
            addToast("Sesión expirada",1)
            navigate('/logout')
          }
          else{
            navigate('/logout')
          }
        })
      } catch (error) {
        console.log(error, "a", typeof(error));
        setCreatingWidget(false);
      }
    }

    const selectAxisV = (selectedItems) => {
      if (parameters && selectedItems){
        const axisV = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.statusField = axisV
        setConf({...tempConf})
      }
      
    }
    const deleteAxisV = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.statusField = undefined
        setConf({...tempConf})
      } 
    }
    const selectAxisH = (selectedItems) => {
      if (parameters && selectedItems){
        const axisH = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.detailField = axisH
        setConf({...tempConf})
      }
    }

    const selectColorPalette = (selectedColor) => {
      if (selectedColor){
        let tempConf = {...conf}
        tempConf.colorPalette = selectedColor
        setConf({...tempConf})
      }
    }
    const selectFixedColor = (selectedColor) => {
      if (selectedColor){
        let tempConf = {...conf}
        tempConf.fixedColor = selectedColor
        setConf({...tempConf})
      }
    }
    const selectTextColor = (selectedColor) => {
      if (selectedColor){
        let tempConf = {...conf}
        tempConf.textColor = selectedColor
        setConf({...tempConf})
      }
    }
    const selectGroupList = (selectedItems) => {
      if (parameters && selectedItems){
        const groupList = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.groupList = groupList
        setConf({...tempConf})
      }
    }
    const selectFilterList = (selectedItems) => {
      if (parameters && selectedItems){
        const filterList = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.filterList = filterList
        setConf({...tempConf})
      }
    }

    // --- FILTROS AVANZADOS ---
      const translateSpanishToCode = (spanish) => {
      switch(spanish) {
        case "Igual a": return "eq";
        case "Diferente de": return "ne";
        case "Mayor a": return "gt";
        case "Menor a": return "lt";
        case "Mayor o igual": return "gte";
        case "Menor o igual": return "lte";
        case "En lista": return "in";
        default: return "";
      }
    };

    const translateRuleCodeToSpanish = (code) => {
      switch(code) {
        case "eq": return "Igual a";
        case "ne": return "Diferente de";
        case "gt": return "Mayor a";
        case "lt": return "Menor a";
        case "gte": return "Mayor o igual";
        case "lte": return "Menor o igual";
        case "in": return "En lista";
        default: return "";
      }
    };

      const handleAddFilterRule = (ruleCode, ruleValue) => {
      setConf(prev => {
        const newRules = prev.filterList?.rules ? [...prev.filterList.rules] : [];
        newRules.push({ code: ruleCode, value: ruleValue });
        return { ...prev, filterList: { ...prev.filterList, rules: newRules } };
      });
    };

    const handleSetFilterField = (field) => {
      setConf(prev => ({
        ...prev,
        filterList: { ...prev.filterList, field }
      }));
    };

    const handleRemoveFilterRule = (index) => {
      setConf(prev => {
        const newRules = [...prev.filterList.rules];
        newRules.splice(index, 1);
        return { ...prev, filterList: { ...prev.filterList, rules: newRules } };
      });
    };

    const handleClearFilter = () => {
      setConf(prev => ({
        ...prev,
        filterList: undefined
      }));
    };
    const deleteAxisH = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.detailField = undefined
        setConf({...tempConf})
      } 
    }
    const deleteFilterList = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.filterList = undefined
        setConf({...tempConf})
      } 
    }
    const deleteGroupList = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.groupList = undefined
        setConf({...tempConf})
      } 
    }
  
    const handleProcessChange = (selectedProcess) => {
      let tempConf = {...conf}
      tempConf.statusField = undefined;
      tempConf.detailField = undefined;
      tempConf.process = {
        id: selectedProcess,
        name: processList[selectedProcess]
      }
      setConf({...tempConf})
    }

    const handleDataRangeChange = (selectedRange) => {
      setDataRange(translateDatePicker(selectedRange));
      let tempConf = {...conf}
      tempConf.dateRange = selectedRange
      setConf({...tempConf})
    }

    const handleTimeVariableChange = (selectedTimeVar) => {
      setTimeVariable(selectedTimeVar);
      let tempConf = {...conf}
      tempConf.timeVariable = selectedTimeVar
      setConf({...tempConf})
    }
    const handleDecimalsChange = (decimals) => {
      let tempConf = {...conf}
      tempConf.nDecimals = decimals
      setConf({...tempConf})
    }
    const handleChangeWidgetName = (name) => {
      setTitle(name)
    }
    const handleCreateWidget = () =>{
      
      //createCard("processTable",title, conf, dashboard._id);
      createWidgetDB();
      
    }
    const handleEditWidget = () =>{
      editWidgetDB();
    }

    useEffect( () => {
      if (selectedProcess){
        //limpiar headers actuales
          
        //cargar los parametros
        refreshParameters();
        //actualizar la configuracion
        handleProcessChange(selectedProcess);

      }
    }, [selectedProcess]);
    useEffect( () => {

        const bdConf = {
          process: undefined,
          statusField: undefined,
          detailField: undefined,
          groupList: undefined,
          filterList:  undefined, 
          dateRange: {
            "activeTab": "customDates",
            "selectedRange": "byDashboard"
          },
          timeVariable: "createdAt",
          nDecimals: 2,
          dateFormat: "mm/dd/yy - hh:mm",
          colorPalette: "fixed",
          fixedColor: "#4287f5",
          textColor: "#000000"
        }
    
        setLoading(true);
        //cargar campos
        //cargar conf
        let processOptions = {}
        menuItems.slice(1).map(element => 
          processOptions[element.id] = element.label
        )
        console.log(processOptions);
        if(id) {
          refreshWidgetInfo()
        }
        else{
          setConf(bdConf);
          
        }
        setProcessList(processOptions);
        setLoading(false);
      }, []);


    useEffect( () => {
      if (id){
        refreshWidgetInfo()
      }
      setFetchingWidgetInfo(false)
      
    }, [id])

    useEffect( () => {
      if (
        title === "" ||
        !conf?.process ||
        !conf.detailField ||
        !conf.statusField ||
        !conf?.dateRange ||
        !conf?.timeVariable ||
        !conf?.nDecimals
      ){
        setValidate(false);
      }
      else {
        setValidate(true);
      }
    }, [conf, title])

    return (
      <>
      {stage === "form" && (
        <>
          {conf && (
              <div className='flex flex-col gap-2 h-[35rem] relative overflow-auto'>
              <div className=' flex flex-col flex-grow gap-2'>
                <CollapsableSection title={"Datos"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' open={true} border={false}>
                  <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center w-[50%] mb-1.5'>
                      <SelectionForm
                        text="Proceso" 
                        options={Object.keys(processList)} 
                        mask={processList} 
                        value={selectedProcess}
                        onChange={event => setSelectedProcess(event)}
                        AppendClassName=' -mb-4'
                        error={!!selectedProcess && !fetchingParameters && parameters.length === 0 ? 'El proceso no tiene parametros creados' : ""}
                      /> 
                    
                    </div>
                  
                      <CollapsableSection 
                        title={"Parametro de Estado"}
                        titleBgColor='bg-aliceblue'
                        titleTextColor='text-gray'
                        open={true}
                      >
                        <div className='w-full flex flex-col px-4'>
                          { conf.statusField && (
                            <ColumnField header={conf.statusField} onDelete={deleteAxisV}/>
                          )}
                          { !conf.statusField && (
                            <div className=' mx-auto'>
                              <ButtonForm 
                                text={"Agregar campo"} 
                                Icon={() => {return (<AddIco fill='white'/>)}} 
                                enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                                action={ () => setStage("setStatus")}
                              />
                            </div>
                          )}
                        </div>
                      </CollapsableSection>

                      <CollapsableSection
                        title={"Parametro de detalle"}
                        titleBgColor='bg-aliceblue'
                        titleTextColor='text-gray'
                        open={true}
                      >
                        <div className='w-full flex flex-col px-4'>
                          { conf.detailField && (
                            <ColumnField header={conf.detailField} onDelete={deleteAxisH}/>
                          )}
                          { !conf.detailField && (
                            <div className=' mx-auto'>
                              <ButtonForm 
                                text={"Agregar campo"} 
                                Icon={() => {return (<AddIco fill='white'/>)}} 
                                enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                                action={ () => setStage("setDetail")}
                              />
                            </div>
                          )}
                        </div>
                      </CollapsableSection>

                      <CollapsableSection
                        title={"Agrupar por"}
                        titleBgColor='bg-aliceblue'
                        titleTextColor='text-gray'
                        open={true}
                      >
                        <div className='w-full flex flex-col px-4'>
                          { conf.groupList && (
                            <ColumnField header={conf.groupList} onDelete={deleteGroupList}/>
                          )}
                          { !conf.groupList && (
                            <div className=' mx-auto'>
                              <ButtonForm 
                                text={"Agregar campo"} 
                                Icon={() => {return (<AddIco fill='white'/>)}} 
                                enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                                action={ () => setStage("setGroupList")}
                              />
                            </div>
                          )}
                        </div>
                      </CollapsableSection>

                    
                    <div className='-mb-5 '>
                      <InputForm 
                        type={"datarange"} 
                        text={"Rango de tiempo"} 
                        value={dataRange} 
                        AppendClassName='text-left' 
                        onChange={(event) => handleDataRangeChange(event)}
                        dateRangeOptions={conf.dateRange}
                        addedRanges={ {"byDashboard": () => {}}} 
                      />
                    </div>

                    <div className='-mb-5 '>
                      <SelectionForm
                        text="Variable de tiempo" 
                        options={Object.keys(variableTimeOptions)} 
                        mask={variableTimeOptions}
                        value={timeVariable}
                        onChange={event => handleTimeVariableChange(event)}
                        AppendClassName=''
                        error={!!selectedProcess && !fetchingParameters && parameters.length === 0 ? 'El proceso no tiene variables de tiempo' : ""}
                      /> 
                    </div>
                    
                  </div>
                </CollapsableSection>
                <CollapsableSection title={"Apariencia"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' border={false} open={true}>
                  <InputForm text={"Nombre"} value={title} onChange={(event) => setTitle(event.target.value)}/>
                  <InputForm type={"number"} text={"Decimales"} value={conf.nDecimals} onChange={(event) => handleDecimalsChange(event.target.value)}/>
                  <InputForm type={"button"} text={"Estilo"} value={"Modificar estilo"} AppendClassName='text-left' onClick={() => {setStage("setAparience")}}/>
                </CollapsableSection>
              </div>

              {/* Span fijo al final del contenedor */}
              <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
                <div className='flex w-full justify-end'>
                    <button className='' onClick={() => id ? handleEditWidget() : handleCreateWidget()}  disabled={!validate}>
                      <CheckIco width='50px' height='50px' fill={validate ? 'bluesens': 'gray'}/>
                    </button>
                </div>
              </div>
            </div>
          )}
          {!conf && (
            <Spinner />
          )}
        </>
        
        
      )}
      {stage === "setStatus" && (
        <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto">
          <div className="flex flex-col flex-grow gap-2">
            {/* Contenedor del dropdown y botón alineado */}
            <div className="flex justify-between items-center w-full">
              <DropdownSelectableList 
                className="flex-grow"
                items={parameters.filter(el => !el.type).map(el => el.alias || el.key)} 
                multiSelect={false} 
                setItems={(selectedItems) => {
                  selectAxisV(selectedItems);
                  // Inicializar reglas si no existen
                  setConf(prev => ({
                    ...prev,
                    statusField: {
                      ...prev.statusField,
                      rules: prev.statusField?.rules || []
                    }
                  }));
                }}
              />
              <button
                className="ml-2 px-3 py-1 bg-bluesens text-white rounded flex items-center gap-1"
                onClick={() => {
                  const newRule = { code: "eq", value: "", color: "#000000" };
                  setConf(prev => ({
                    ...prev,
                    statusField: {
                      ...prev.statusField,
                      rules: [...(prev.statusField.rules || []), newRule]
                    }
                  }));
                }}
              >
                Agregar regla
              </button>
            </div>

            {/* Reglas de color */}
            {conf.statusField?.rules && conf.statusField.rules.map((rule, index) => (
              <div key={index} className="flex items-center gap-2 w-full">
                <select
                  value={rule.code}
                  onChange={(e) => {
                    const newRules = [...conf.statusField.rules];
                    newRules[index].code = e.target.value;
                    setConf(prev => ({
                      ...prev,
                      statusField: { ...prev.statusField, rules: newRules }
                    }));
                  }}
                  className="border p-1 rounded flex-shrink-0"
                >
                  <option value="eq">Igual a</option>
                  <option value="ne">Diferente de</option>
                  <option value="gt">Mayor a</option>
                  <option value="lt">Menor a</option>
                  <option value="gte">Mayor o igual</option>
                  <option value="lte">Menor o igual</option>
                  <option value="in">En lista</option>
                </select>

                <input
                  type="text"
                  value={rule.value}
                  placeholder="Valor"
                  className="border p-1 rounded flex-grow"
                  onChange={(e) => {
                    const newRules = [...conf.statusField.rules];
                    newRules[index].value = e.target.value;
                    setConf(prev => ({
                      ...prev,
                      statusField: { ...prev.statusField, rules: newRules }
                    }));
                  }}
                />

                <input
                  type="color"
                  value={rule.color || "#000000"}
                  onChange={(e) => {
                    const newRules = [...conf.statusField.rules];
                    newRules[index].color = e.target.value;
                    setConf(prev => ({
                      ...prev,
                      statusField: { ...prev.statusField, rules: newRules }
                    }));
                  }}
                  className="flex-shrink-0"
                />

                <button
                  onClick={() => {
                    const newRules = [...conf.statusField.rules];
                    newRules.splice(index, 1);
                    setConf(prev => ({
                      ...prev,
                      statusField: { ...prev.statusField, rules: newRules }
                    }));
                  }}
                  className="flex-shrink-0"
                >
                  <TrashIco fill="red" />
                </button>
              </div>
            ))}
          </div>

          {/* Span fijo al final del contenedor */}
          <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
            <div className="flex w-full justify-end">
              <ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')} />
            </div>
          </div>
        </div>
      )}


      {stage === "setDetail" && (
        <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
          <div className=' flex flex-col flex-grow gap-2'>
            <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
            <SelectableList 
              items={parameters.filter(el => !el.type).map(el => el.alias || el.key)} 
              multiSelect={false} 
              setItems={selectAxisH}
            />
          </div>
          
          {/* Span fijo al final del contenedor */}
          <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
            <div className='flex w-full justify-end'>
              < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
            </div>
          </div>
        </div>
      )}

      {stage === "setGroupList" && (
        <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
          <div className=' flex flex-col flex-grow gap-2'>
            <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
            <SelectableList 
              items={parameters.filter(element => !element.type  ).map(element => element.alias ? element.alias : element.key)} 
              multiSelect={false} 
              setItems={selectGroupList}
            />
          </div>
          
          {/* Span fijo al final del contenedor */}
          <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
            <div className='flex w-full justify-end'>
              < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
            </div>
          </div>
        </div>
      )}

      {/* Apariencia */} 
      {stage === "setAparience" && (
        <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto">
          <div className="flex flex-col flex-grow gap-2">
            <span className="font-semibold text-lg">Modificar estilo</span>

            
            <InputForm
              id="textColor"
              type="color"
              text="Seleccionar color del texto"
              value={conf?.textColor || "#000000"}
              onChange={(event) => selectTextColor(event)}
            />
          </div>

          {/* Botón fijo al final */}
          <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
            <div className="flex w-full justify-end">
              <ButtonForm
                text={"Guardar"}
                enabled={true}
                action={() => setStage("form")}
              />
            </div>
          </div>
        </div>
      )}

      </>
    
      
    );
  }

  export default StatusRegisterForm;
